import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import '@/styles/InitiativeTracker/CombatLogs.less';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/assets/icons/LibrarySvg';
import { useCombatLogs } from '@/context/CombatLogsContext';
import { CombatLogActionType } from '@/types/combatLogTypes';
import { formatTime } from '@/utils/dateTime';
const CombatLogs = ({ combatMap, pageButtonsContainer, showToggleButton = true, }) => {
    const { t } = useTranslation();
    const logsRef = useRef(null);
    const { combatLogs, fetchLogs, clearLogs } = useCombatLogs();
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        fetchLogs(combatMap.id);
    }, [combatMap.id, fetchLogs]);
    // Автоматическая прокрутка вниз при обновлении логов
    useEffect(() => {
        if (logsRef.current) {
            logsRef.current.scrollTop = logsRef.current.scrollHeight;
        }
    }, [combatLogs, isOpen]);
    const messageElement = (log) => {
        return _jsx("span", { className: "log-message", children: log.message });
    };
    const nextRoundElement = (log) => {
        return (_jsxs("span", { className: "log-message", children: [t('combatLogs.round').toUpperCase(), " ", log.actionValue] }));
    };
    const nextTurnElement = (log) => {
        return (_jsx(_Fragment, { children: _jsx("span", { className: "log-action", children: t('combatLogs.nextTurn') }) }));
    };
    const statusElement = (log) => {
        return (_jsxs(_Fragment, { children: [_jsx("span", { className: "log-action-character", children: log.actionCharacter }), _jsx("span", { className: "log-action", children: t('combatLogs.statusApply') }), _jsx("span", { className: "log-action-value", children: log.actionValue }), _jsx("span", { className: "log-action-character", children: log.affectedCharacters })] }));
    };
    const logElement = (log) => {
        return (_jsxs(_Fragment, { children: [_jsx("span", { className: "log-time", children: formatTime(log.createdAt) }), _jsx("span", { className: "log-action-character", children: log.actionCharacter }), _jsx("span", { className: "log-action", children: log.action === CombatLogActionType.DAMAGE
                        ? t('combatLogs.attack').toLowerCase()
                        : log.action === CombatLogActionType.HEAL
                            ? t('combatLogs.heal').toLowerCase()
                            : log.action }), _jsx("span", { className: "log-action-value", children: log.actionValue }), log.affectedCharacters &&
                    log.affectedCharacters.split(',').map((characterName, idx) => (_jsx("span", { className: "log-action-character", style: { margin: '0 2px', whiteSpace: 'nowrap' }, children: characterName.trim() }, idx))), log.actionResult && (_jsx(_Fragment, { children: _jsxs("span", { className: "log-action-result", style: { fontSize: '0.68rem' }, children: ['-> ', log.actionResult] }) }))] }));
    };
    return (_jsxs(_Fragment, { children: [isOpen && (_jsxs("div", { className: "combat-logs-container", children: [_jsxs("div", { className: "header", children: [t('combatLogs.title'), _jsx("button", { type: "button", title: "Clear logs", className: "clear-logs-btn icon-btn", onClick: () => clearLogs(combatMap.id), children: _jsx(Icon, { name: "trash" }) })] }), _jsx("div", { className: "logs", ref: logsRef, children: combatLogs.map((log) => {
                            return (_jsx("div", { className: `log-entry ${log.action}`, children: log.action === CombatLogActionType.MESSAGE
                                    ? messageElement(log)
                                    : log.action === CombatLogActionType.NEXT_ROUND
                                        ? nextRoundElement(log)
                                        : logElement(log) }, log.id));
                        }) })] })), pageButtonsContainer &&
                showToggleButton &&
                createPortal(_jsx("button", { className: "combat-logs-toggle-button", style: { order: 10 }, title: "Show combat log", onClick: () => setIsOpen((v) => !v), children: _jsx(Icon, { name: "swords_1" }) }), pageButtonsContainer)] }));
};
export default CombatLogs;
